<script lang="ts" setup>
import type { SearchFilterOptionWithFilterName } from '@/components/Search/types'
import iconRemoveFilter from '@/assets/img/icon-search-result-header-remove-filter.svg'
import { computed } from 'vue';
import { formatDate } from '@/utils/dateHelpers';

//props
const props = withDefaults(defineProps<{
  selectedFilters?: SearchFilterOptionWithFilterName[]
}>(), {
  selectedFilters: () => []
})

// emits
const emit = defineEmits(['removeFilter'])

const removeFilter = (item: SearchFilterOptionWithFilterName) => {
  emit('removeFilter', item)
}

const nonEmptySelectedFilters = computed(() =>
  props.selectedFilters.filter(
    (item) => {
      if(item.text instanceof Date) {
        return true;
      }
      const itemText = (item.text ?? '').toString().trim().toLowerCase();
      return itemText !== '' && itemText !== 'all' && itemText !== 'documenttype';
    }
  )
)
const selectionFormatted = (itemText: any) => {
  if (itemText instanceof Date) {
    return formatDate(itemText);
  } else {
     return itemText.toString().replace(/\s*\(\s*\d+\s*\)\s*$/, ''); //strip out counts "(num)"
  } 
}
</script>

<template>
  <div class="selected-filters">
    <div class="selected-filter-item" v-for="(item, index) in nonEmptySelectedFilters" :key="index">
      <div class="selected-filter-text">{{ selectionFormatted(item.text) }}</div>
      <div class="selected-filter-remove" @click="removeFilter(item)">
        <img :src="iconRemoveFilter" alt="Remove filter" />
      </div>
    </div>
    <slot name="afterFilters"></slot>
  </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>